export default __webpack_public_path__ + "static/media/GlyGen-slides-template.7ef132ac.pptx";